<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false">
      <van-tab title="全部" :badge="advancesCount.cgCount != 0?advancesCount.cgCount:''"></van-tab>
      <van-tab title="长期垫款" :badge="advancesCount.bhCount != 0?advancesCount.bhCount:''"></van-tab>
      <van-tab title="临时垫款" :badge="advancesCount.bmCount != 0?advancesCount.bmCount:''"></van-tab>
      <van-tab title="垫款特批" :badge="advancesCount.qwCount != 0?advancesCount.qwCount:''"></van-tab>
      <!-- <van-tab title="临时垫款特批" :badge="advancesCount.qwCount != 0?advancesCount.qwCount:''"></van-tab> -->
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index" @click="toDetails(item)">
        <div class="flex-c-center" v-if="item">
         <div>
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.contractName }}
              </div>
            </div>
            <div>
              <div>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.templateType">{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.payType">{{ formatHandel('payType',item.payType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.frameType">{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#999" plain type="primary" v-if="item.custSource">{{ formatHandel('custSource',item.custSource) }}</van-tag>
              </div>
              <!-- <div style="color: #07c160; font-size: 12px">合同金额(元)：{{item.contractMoney}} </div> -->
              <div style="color: #1989fa; font-size: 12px">垫款金额(元)：{{item.payMoney}} <span style="color: #ff976a;margin-left: 5px">回款金额(元)： {{item.inMoney || '-'}}</span></div>
              <div style="color: #07c160; font-size: 12px">充值剩余金额(元)：{{item.rechargeRemainMoney}} </div>
              <div style="font-size: 12px">充值过期时间：{{item.rechargeTime}} </div>
              <div style="color: #999; font-size: 12px">{{item.deptName}}<span style="color: #1989fa;margin-left: 5px;margin-right: 5px">{{item.custSource === 2?item.addUserName:item.userName}}</span>  {{item.createTime}}</div>
            </div>
          </div>
          <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color"  @click="toDetails(item)" />

        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import moment from 'moment'
// import newContract from '@/api/cont/newContract'
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPop from '../components/contract/SearchPop.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Tab, Tabs } from 'vant'
export default {
  name: 'approve',
  components: {
    SearchComponent,
    SearchPop,
    EmptyComponent,
    TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      deptTreeList: [],
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      options: {},
      advancesCount: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: '',
        contractName: '',
        serviceTypeId: '',
        templateType: null,
        payType: null,
        checkStatus: '6',
        advancesType: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 框架类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    await this.handleList()
    await this.getContCount()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '垫款查询'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.getContCount({ contractName: data })
      this.queryParams.contractName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.getContCount(data)
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/advances/detail',
        query: { id: item.contAdvancesId, active: this.active }
      })
    },
    async handleList() {
      this.loading = true
      const res = await payment.listAdvances(this.queryParams)

      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    async getContCount(query) {
      // const res = await payment.getCountAdvances(query)
      // if (res.code === 200) {
      //   this.advancesCount = res.data
      // }
    },
    onLoad() {
      this.handleList()
      this.getContCount()
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    handleClick(tab, event) {
      if (tab == 0) {
        this.queryParams.advancesType = null
      } else {
        this.queryParams.advancesType = tab
      }
      this.queryCustList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>
